import React from "react";

const CAT = {
  "High Priority": "bg-emerald-100 text-emerald-800 border-emerald-200 dark:bg-emerald-950/60 dark:text-emerald-300",
  Qualified: "bg-sky-100 text-sky-800 border-sky-200 dark:bg-sky-950/60 dark:text-sky-300",
  "Documents Pending": "bg-amber-100 text-amber-800 border-amber-200 dark:bg-amber-950/60 dark:text-amber-300",
  "Needs Verification": "bg-amber-100 text-amber-800 border-amber-200 dark:bg-amber-950/60 dark:text-amber-300",
  Duplicate: "bg-rose-100 text-rose-800 border-rose-200 dark:bg-rose-950/60 dark:text-rose-300",
  "Manual Review": "bg-slate-100 text-slate-700 border-slate-200 dark:bg-slate-800 dark:text-slate-300",
};

export function QualityBadge({ quality, showReasons = false }) {
  if (!quality) return <span className="text-xs text-muted-foreground">Not scored</span>;
  const tip = [...(quality.reasons || []), ...(quality.missing || []).map((m) => `— missing: ${m}`)].join("\n");
  return (
    <div title={tip} data-testid="quality-badge">
      <span className={`inline-flex items-center gap-1.5 border rounded-full px-2.5 py-0.5 text-xs font-semibold whitespace-nowrap ${CAT[quality.category] || CAT["Manual Review"]}`}>
        <span className="tabular-nums">{quality.score}</span>· {quality.category}
      </span>
      {showReasons && (
        <ul className="mt-1.5 text-[11px] text-muted-foreground space-y-0.5" data-testid="quality-reasons">
          {(quality.reasons || []).map((r) => <li key={r}>{r}</li>)}
          {(quality.missing || []).map((m) => <li key={m} className="opacity-70">Missing: {m}</li>)}
        </ul>
      )}
    </div>
  );
}
